import script from "./BulkEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkEdit.vue?vue&type=script&setup=true&lang=js"

import "./BulkEdit.vue?vue&type=style&index=0&id=01702d76&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01702d76"]])

export default __exports__